<template>
  <div id="calendar-file">
    <!-- <h2>{{$t("ideas.top.email.form.email")}}</h2> -->
    <div class="form-container">
      <div class="input-container">
        <label>{{$t('calendar.file.title')}}</label>
        <FileUploader
          :placeholder="$t('calendar.file.file_ph')"
          :type="'.pdf'"
          :label="$t('calendar.file.browse')"
          :fileUrl="fileUrl"
          @setFile="setFile"
        />
        <div v-if="$v.file.$error" class="error-msg">
          <p>{{$t("calendar.file.errors.file_required")}}</p>
        </div>
      </div>
      <button
        class="save-btn"
        :disabled="isLoading"
        @click="validateForm"
      >{{$t("ideas.top.email.form.update")}}</button>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import API_SERVICE from "@/lib/api/Calendar.js";
import S3_Handler from "@/lib/api/s3_handler";
const FileUploader = () => import("@/components/FileUploader");
const api = new API_SERVICE();
const s3 = new S3_Handler();

export default {
  components: {
    FileUploader
  },
  data: function() {
    return {
      isLoading: false,
      file: null,
      fileUrl: null,
      signedURL: null
    };
  },
  validations: {
    file: {
      required
    }
  },
  beforeMount: async function() {
    await this.getFile();
  },
  methods: {
    getFile: async function() {
      this.isLoading = true;
      this.$store.commit("global/SET_LOADING", true);
      try {
        const response = await api.getCalendarFile();
        this.fileUrl = response.source;
        const urlResp = s3.getSignedUrl(this.fileUrl);
        this.signedURL = urlResp;
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    setFile: function(file) {
      this.file = file;
    },
    validateForm: async function() {
      this.$v.$touch();
      if (this.$v.$error) return;
      await this.uploadFile();
    },
    uploadFile: async function() {
      this.isLoading = true;
      this.$store.commit("global/SET_LOADING", true);
      try {
        const timestamp = Date.now();
        const filename = `${timestamp}_calendar.pdf`;
        const response = await s3.uploadFile(filename, this.file);
        await api.postCalendarFile(response.Location);
        this.$store.commit("global/SET_LOADING", false);
        this.isLoading = false;
        this.file = null;
        this.fileUrl = null;
        this.$v.$reset();
        await this.getFile();
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.isLoading = false;
        throw error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#calendar-file {
  margin: 2rem 0;
}
h2 {
  font-size: 1.5rem;
}
.form-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.form-container > * {
  margin-right: 2rem;
}
.input-container {
  width: 25%;
  label {
    @extend %audi-b;
  }
}
.save-btn {
  @extend %audi-b;
  color: $black;
  background-color: transparent;
  border: 1px solid $black;
  padding: 5px 10px;
}
.error-msg {
  color: $warn_red;
  font-size: 14px;
  p {
    margin: 0;
  }
}
</style>